module.exports = __webpack_public_path__ + "img/team-card-avatar.52d6684e.svg";